import React from "react";
import { Tabs } from "@mantine/core";
import { useTranslation } from "react-i18next";
import EasyOrders from "./EasyOrders";
import EasyOrdersAPIKeys from "./EasyOrdersAPIKeys";
import { Helmet } from "react-helmet";

const EasyOrdersTabs = () => {

  const [_] = useTranslation("global");

  return (
    <Tabs defaultValue="gallery" className="w-100">
      <Helmet>
        <title>{_("panel.easyOrders")}</title>
      </Helmet>
      <Tabs.List>
        <Tabs.Tab value="gallery" className="fs-5" color="rgb(89, 198, 201)">
          {_("panel.link")}
        </Tabs.Tab>
        <Tabs.Tab value="messages" className="fs-5" color="rgb(89, 198, 201)">
          {_("panel.keys")}
        </Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="gallery">
        <EasyOrders />
      </Tabs.Panel>

      <Tabs.Panel value="messages">
        <EasyOrdersAPIKeys />
      </Tabs.Panel>
    </Tabs>
  );
};

export default EasyOrdersTabs;
